export const GET_STYLING_FIRMS_SUCCESS = 'GET_STYLING_FIRMS_SUCCESS';
export const GET_STYLING_FIRM_SUCCESS = 'GET_STYLING_FIRM_SUCCESS';

export const SAVE_STYLING_FIRM_SUCCESS = 'SAVE_STYLING_FIRM_SUCCESS';
export const UPDATE_STYLING_FIRM_FORM_SUCCESS = 'UPDATE_STYLING_FIRM_FORM_SUCCESS';

export const GET_STYLING_FIRM_PRODUCTS_SUCCESS = 'GET_STYLING_FIRM_PRODUCTS_SUCCESS';
export const ADD_STYLING_FIRM_PRODUCT_SUCCESS = 'ADD_STYLING_FIRM_PRODUCT_SUCCESS';

export const DELETE_STYLING_FIRM_SUCCESS = 'DELETE_STYLING_FIRM_SUCCESS';
